// extracted by mini-css-extract-plugin
export default {"header":"header__1sGEo","lightMode":"lightMode__1gUjL","headerInner":"headerInner__2GCe1"};